import { deviceRows } from '@/mocks/downloadData';

export default function Devices() {
  return (
    <section id="devices" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-device-line"></i>
            DEVICES
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            兼容设备与环境要求
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed">
            安装前对照下表确认设备可以正常运行。达到推荐配置时，播放与加载体验会更流畅。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[640px] text-left border-collapse">
              <thead>
                <tr className="bg-background-200/60 text-foreground-600 text-xs">
                  <th className="px-5 py-3.5 font-medium">平台 / 设备</th>
                  <th className="px-5 py-3.5 font-medium">最低要求</th>
                  <th className="px-5 py-3.5 font-medium">推荐配置</th>
                  <th className="px-5 py-3.5 font-medium">存储 / 说明</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-background-200">
                {deviceRows.map((row) => (
                  <tr key={row.platform} className="hover:bg-background-100 transition-colors">
                    <td className="px-5 py-4 text-foreground-950 text-sm font-medium whitespace-nowrap">
                      {row.platform}
                    </td>
                    <td className="px-5 py-4 text-foreground-700 text-sm">{row.min}</td>
                    <td className="px-5 py-4 text-foreground-700 text-sm">
                      <span className="inline-flex items-center gap-1.5">
                        <i className="ri-check-line text-secondary-600"></i>
                        {row.recommend}
                      </span>
                    </td>
                    <td className="px-5 py-4 text-foreground-600 text-sm">{row.storage}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}